import authRootSaga from '$src/auth/sagas'
import {fork, getContext, call} from 'redux-saga/effects'
import comparableSalesRootSaga from '$src/comparableSales/sagas/sagas'
import usersRootSaga from '$src/users/sagas'
import notificationsRootSaga from '$src/notifications/sagas'
import {IStore} from './Store'

export function* rootSaga(): Generator {
  const store = (yield getMstStore()) as IStore
  let lastCatch = Date.now()
  while (true) {
    try {
      yield call(run)
    } catch (e) {
      if (Date.now() - lastCatch < 100) {
        store.errors.add({message: 'Unexpected loop occured: ' + e.message})
        console.error('error loop', e)
        return
      }
      console.error(e)
      store.errors.add({message: 'Unexpected error occured: ' + e.message})
    }
  }
}

function* run(): Generator {
  yield fork(authRootSaga)
  yield fork(comparableSalesRootSaga)
  yield fork(usersRootSaga)
  yield fork(notificationsRootSaga)
}

export function getMstStore(): Generator<unknown, IStore, unknown> {
  return getContext('mstStore') as $FixMe
}



// WEBPACK FOOTER //
// ./src/bootstrap/rootSaga.tsx